import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import dp from '../assets/images/erick.png';
import '../assets/styles/Main.scss';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={dp} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/MuthomiEric" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/erickmuthomi/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Erick Muthomi</h1>
          <p>Software Engineer | Fintech | Distributed Systems</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/MuthomiEric" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/erickmuthomi/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;